<template>
 
      <textarea rows="100" cols="103">This is a notepad, write whatever you like!
</textarea>
 


</template>
<script>
export default {
        
}
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/notes.vue